import { render, staticRenderFns } from "./SimpleProcessHistoryWidget.vue?vue&type=template&id=369a5b07&scoped=true&"
import script from "./SimpleProcessHistoryWidget.vue?vue&type=script&lang=js&"
export * from "./SimpleProcessHistoryWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369a5b07",
  null
  
)

export default component.exports